<template>
  <header class="flex flex-wrap items-center justify-between p-4">
    <h1 class="font-bold uppercase hidden md:block">
      <router-link :to="{ name: 'home' }">
        <img src="/img/timelapse-logo.png" class="inline-block w-24 md:w-32" />
      </router-link>
    </h1>

    <nav class="w-full md:w-auto mt-2 md:mt-0">
      <ul class="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-4">
        <li v-for="link in links" :key="link.name" class="w-full md:w-auto">
          <router-link
            :to="{ name: link.name }"
            class="text-center w-full md:w-auto block py-2 px-4 rounded-lg font-semibold"
            :class="{
              'bg-primary text-white': isActive(link),
              'text-gray-700 hover:bg-gray-200': !isActive(link),
              'md:hover:bg-transparent md:hover:text-primary': !isActive(link),
            }"
          >
            {{ link.label }}
          </router-link>
        </li>
      </ul>
    </nav>

    <div class="relative w-full md:w-auto text-center md:text-left mt-2 md:mt-0">
      <div class="relative inline-block">
        <button
          class="flex items-center justify-center md:justify-start outline-none focus:outline-none w-full"
          id="options-menu"
          aria-expanded="true"
          aria-haspopup="true"
          @click="isOpen = !isOpen"
        >
          <span>{{ user.user.email }}</span>
          <i class="tmlps-i-arrow-down text-2xl"></i>
        </button>

        <div
          v-if="isOpen"
          class="top-8 w-full md:w-60 p-1 shadow-xl absolute bg-white border border-gray-300"
          role="menu"
        >
          <button
            @click="handlerLogout"
            class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
          >
            Salir
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Header',
  computed: {
    ...mapState(['user']),
  },
  data() {
    return {
      isOpen: false,
      links: [
        { name: 'home', label: 'Empresas' },
        { name: 'admins', label: 'Administradores' },
        { name: 'whatsapp-settings', label: 'WhatsApp' },
      ],
    };
  },
  methods: {
    /**
     * "Empresas" se queda marcado en todas las pantallas que cuelgan de una
     * empresa (proyectos, usuarios, camaras), que no tienen liga propia.
     */
    isActive(link) {
      const ownSections = ['admins', 'whatsapp-settings'];

      return link.name === 'home'
        ? !ownSections.includes(this.$route.name)
        : this.$route.name === link.name;
    },
    handlerLogout() {
      this.$store.dispatch('auth/logout');
    },
  },
};
</script>
